import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { Card, CardContent } from '@guildeducationinc/recess';
import { AdminTopNav } from '@src/components/Admin/AdminTopNav/AdminTopNav';
import { DashboardMonthlyActivity } from '@src/components/Admin/Dashboard/DashboardMonthlyActivity/DashboardMonthlyActivity';
import { DashboardSpendStats } from '@src/components/Admin/Dashboard/DashboardSpendStats';
import { DashboardUtilizationStats } from '@src/components/Admin/Dashboard/DashboardUtilizationStats';
import { BudgetProgress } from '@src/components/BudgetProgress';
import { BENEFIT_PERIODS } from '@src/graphql/queries/benefitPeriod';
import { useClientIdParam } from '@src/hooks/useClientIdParam';
import { useClients } from '@src/hooks/useClients';
import { BenefitPeriodType } from '@src/types';
import { DropdownSelect, useLocale } from 'pe-core-frontend';
import { useMemo, useState } from 'react';
import styles from './Dashboard.module.scss';
export const Dashboard = () => {
    const clientId = useClientIdParam();
    const { find } = useClients({ id: clientId });
    const client = clientId ? find(clientId) : null;
    const { t } = useLocale();
    const [year, setYear] = useState(new Date().getFullYear());
    const { data: benefitsData } = useQuery(BENEFIT_PERIODS, {
        variables: {
            spec: {
                type: BenefitPeriodType.CAP_YEAR,
                clientId,
            },
            skip: !clientId,
        },
    });
    const yearOptions = useMemo(() => {
        return benefitsData?.benefitPeriods
            .slice()
            .sort((a, b) => b.year - a.year)
            .map((benefitPeriod) => ({
            label: benefitPeriod.year.toString(),
            value: benefitPeriod.year.toString(),
        }));
    }, [benefitsData]);
    return (_jsxs("div", { children: [_jsx(AdminTopNav, { title: t('Overview'), actions: _jsx(DropdownSelect, { color: 'primary', variant: 'contained', btnStyle: { padding: '6px 16px' }, label: t('Benefit Period Year'), options: yearOptions || [], value: year?.toString() || '', onChange: e => setYear(e.target.value ? Number(e.target.value) : undefined) }) }), _jsx("div", { children: (year && client && (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.metrics, children: [_jsx(DashboardSpendStats, { client: client, year: year || 0 }), _jsx(DashboardUtilizationStats, { client: client, year: year || 0 })] }), _jsx("div", { className: 'w-full mt-4', children: _jsx(DashboardMonthlyActivity, { client: client, year: year || 0 }) }), _jsx("div", { className: 'w-full mt-4', children: _jsx(Card, { className: styles.budgetCard, children: _jsxs(CardContent, { children: [_jsx("h3", { children: "Budget Overview" }), _jsx(BudgetProgress, { clientId: clientId, year: year, description: 'Budget is calculated across all budget policies.' })] }) }) })] }))) ||
                    t('Select a year to view spend stats.') })] }));
};
